import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import { BodyLargeBold } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const SaleItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SaleItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SaleItemInfo = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProductName = styled.div`
  ${BodyLargeBold};
  text-align: left;
  color: ${LayoutColors.blackMain};
`;

export const SaleItemLabelValue = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;
`;

export const PurchaseResume = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResumeValue = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: right;
  color: #4d4d4d;
`;

export const AlertContentWrapper = styled.div`
  display: flex;
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  flex-direction: column-reverse;
  margin-left: -38px;
  flex: 1;
  justify-content: space-between;

  svg {
    margin-left: auto;
    flex-shrink: 0;
    cursor: pointer;
  }

  p {
    margin-top: 16px;
  }

  ${device.smallTablet} {
    margin-left: 0px;
    flex-direction: row;

    svg {
      margin-left: 16px;
    }

    p {
      margin-top: 0;
    }
  }
`;
